import { IbanState } from './iban.model'

interface PaymentOwner {
  owner: Owner
  name: string
  firstName: string
  lastName: string
  docId: string
}

export type ContractDestination = {
  id: string
  value: string
}
export interface PaymentsState {
  iban: IbanState
  paymentOwner: PaymentOwner
  address: string
  contractDestination?: ContractDestination
}
export interface Billing {
  iban: string | null
  paymentOwner: PaymentOwner
}

export enum Owner {
  SAME = 'SAME',
  OTHER = 'OTHER',
  EMPTY = '',
}
